import './App.css'
import Main from './containers/Main'
import { withAuthenticator } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'
import { Amplify } from 'aws-amplify'
import config from "./config"

Amplify.configure({
  Auth: {
    Cognito: {
      region: config.cognito.REGION,
      userPoolId: config.cognito.USER_POOL_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID
    }
  },
  API: {
    REST: {
      NextUIBus: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
      LatestUIProjects: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION        
      },
      Status: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION        
      },
      SuspendFile: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
      Quotes: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
      Notes: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
      LocmanUI: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
      LocmanQueries: {
        endpoint: config.apiGateway.QUERIES_URL,
        region: config.apiGateway.REGION
      }
    }
  }
});

export default withAuthenticator(Main, { hideSignUp: true })

